import React, { useEffect, useMemo, useRef } from "react";
import { Button, Tabs } from "antd";
import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";
import { useApplicationStateValue } from "../application/Application";
import { strings } from "../languages/Localize";
import starFullSvg from "../assets/images/star-full-white.svg";
import PanelTypes from "./PanelTypes";
import SpeechBlock from "./agenda-items/SpeechBlock";
import Break from "./agenda-items/Break";
import routes from "../config/routes";
import { checkIfIOS } from "../util/util";

const { TabPane } = Tabs;

const StyledHeaderContainer = styled(Flex)`
    height: 7%;
    justify-content: space-between;
    align-items: center;
`;

const StyledHeaderLabel = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
`;

const StyledHeaderButton = styled(Button)`
    && {
        display: flex;
        border-radius: 4px;
        color: ${({ theme }) => theme.colors.white};
        border-color: ${({ theme }) => theme.colors.white};
        background: transparent;
        text-align: center;
    }
    &&:hover,
    &&:active {
        outline: none;
    }
`;

const StyledHeaderButtonIcon = styled.span`
    && {
        background: url(${starFullSvg}) center no-repeat;
        background-size: 19px;
        height: 19px;
        margin-right: 4px;
        width: 19px;
    }
`;

const StyledPanelContainer = styled(Flex)`
    flex-direction: column;
    height: 93%;
`;

const StyledPanelTabsHeaderLine = styled.hr`
    background: ${({ theme }) => theme.colors.white};
    position: relative;
    display: block;
    top: 7px;
    margin: 0;
    z-index: -5;
`;

const StyledTabs = styled(Tabs)`
    &&.ant-tabs {
        height: 100%;
    }
    && .ant-tabs-nav {
        height: 40px;
        margin-bottom: 0;
        width: 100%;
    }

    && .ant-tabs-tab {
        width: 50%;
        background: transparent;
        border-color: transparent;
        color: ${({ theme }) => theme.colors.white};
        font-size: 16px;
    }
    && .ant-tabs-tab-active {
        .ant-tabs-tab-btn {
            background: ${({ theme }) => theme.colors.white};
            color: ${({ theme }) => theme.colors.primary};
            font-weight: 600;
            
        }
        border-color: ${({ theme }) => theme.colors.white};
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.primary};
        border-bottom: 1px solid #183271 !important;
    }
    && span[unselectable="unselectable"] {
        display: none;
    }
    && .ant-tabs-nav-container-scrolling {
        padding: unset;
    }
    && .ant-tabs-bar {
        border-bottom: 2px solid ${({ theme }) => theme.colors.white};
        margin: 0;
    }
    && .ant-tabs-content {
        height: 100%;
    }
    && .ant-tabs-tabpane {
        height: 100%;
    }
`;

const StyledItemsContainer = styled.div`
    overflow: auto;
    width: 100%;
    height: 100%;
    padding-bottom: ${({ isios }) => (isios ? "70px" : "0px")};
`;

const StyledTabPane = styled(TabPane)`
    position: relative;
    top: ${({ moveToTop }) => (moveToTop ? `-100` : `0`)}%;
`;

const Panels = ({ history }) => {
    const {
        appData: { forumSchedule },
        setPosition,
        position
    } = useApplicationStateValue();
    const onTabChange = e => console.log(e);
    const tabOne = useRef(null);
    const tabTwo = useRef(null);
    const tabThree = useRef(null);
    const refs = useMemo(() => [tabOne, tabTwo, tabThree], []);

    useEffect(() => {
        refs[position.id].current.scrollTop = position.top;
    }, [refs, position]);

    const positionHandler = id => setPosition({ id, top: refs[id].current.scrollTop });

    const tabPanes = forumSchedule.map((schedule, tabId) => {
        let moveToTop = false;
        /*if (tabId !== currentTab) {
            setCurrentTab(tabId);
            moveToTop = true;
        }*/

        const items = schedule.agenda.map((item, id) => {
            if (item.itemType === PanelTypes.PANEL) {
                return <SpeechBlock item={item} key={`${forumSchedule.label}#${id}`} positionHandler={positionHandler.bind(null, tabId)} />;
            } else if (item.itemType === PanelTypes.BREAK) {
                return <Break item={item} key={`${forumSchedule.label}#${id}`} />;
            }
            return null;
        });
        return (
            <StyledTabPane moveToTop={moveToTop} tab={schedule.label} key={tabId}>
                <StyledItemsContainer isios={checkIfIOS() ? 1 : 0} ref={refs[tabId]}>
                    {items}
                </StyledItemsContainer>
            </StyledTabPane>
        );
    });
    return (
        <>
            <StyledHeaderContainer paddingX={[4, 5]} paddingBottom={2}>
                <StyledHeaderLabel fontWeight="semiBold" fontSize={[6]}>
                    {strings.panel.HEADER}
                </StyledHeaderLabel>
                <StyledHeaderButton padding={2} fontSize={[3, 4]} shape="round" onClick={() => history.push(routes.PANELS_FAVORITE)}>
                    <StyledHeaderButtonIcon />
                    {strings.panel.FAVORITE_PANELS}
                </StyledHeaderButton>
            </StyledHeaderContainer>
            <StyledPanelContainer>
                <StyledPanelTabsHeaderLine />
                <StyledTabs type="card" defaultActiveKey={position.id.toString()} onChange={onTabChange}>
                    {tabPanes}
                </StyledTabs>
            </StyledPanelContainer>
        </>
    );
};
export default Panels;
